import Nav from "../Nav";
import Carousel from "../Carousel";
import { Link } from "react-router-dom";
import Head from "../Head";

export const RamitaMuestra = () => {
  var settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: true,
    autoplaySpeed: 2000,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          dots: false,
          arrows: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          arrows: false,
        },
      },
    ],
  };
  return (
    <>
      <Head title="Muestras - Una ramita que atraviesa el aire" />
      <Nav titulo="Una ramita que atraviesa el aire" link="/muestras" />
      <section
        id="about_me"
        className="mb-5  animate__fadeInDown wow animate__animated animate__delay-0s animate__slower"
      >
        <Carousel settings={settings}>
          <img
            src="../img/fotogramas/una_ramita (1).jpg"
            className="img-fluid"
            alt="Una ramita que atraviesa el aire"
          />
          <img
            src="../img/fotogramas/una_ramita (2).jpg"
            className="img-fluid"
            alt="Una ramita que atraviesa el aire"
          />
          <img
            src="../img/fotogramas/una_ramita (3).jpg"
            className="img-fluid"
            alt="Una ramita que atraviesa el aire"
          />
          <img
            src="../img/fotogramas/una_ramita (4).jpg"
            className="img-fluid"
            alt="Una ramita que atraviesa el aire"
          />
          <img
            src="../img/fotogramas/una_ramita (5).jpg"
            className="img-fluid"
            alt="Una ramita que atraviesa el aire"
          />
          <img
            src="../img/fotogramas/una_ramita (6).jpg"
            className="img-fluid"
            alt="Una ramita que atraviesa el aire"
          />
        </Carousel>
        <div className="row marMob ">
          <div className="col-12 mt-5 col-lg-7 fondoImg text-md-start col-xl-9">
            <hr />
            <Link to="/proyectos/una_ramita">
              <h3 className="text-center fs-6">
                Rosario, 2022 - Museo de ciencias naturales Angel Gallardo
              </h3>
              <hr />
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};
